// extracted by mini-css-extract-plugin
module.exports = {"main__cont":"analitics_main__cont__3RPpY","button_down":"analitics_button_down__3I7fy","selobj":"analitics_selobj__2wDKD"};